module.exports = __webpack_public_path__ + "img/logo-dark.e8f46948.svg";